import { WSS } from '../../../ws'
import type { Starter, Options, WSOptions } from '../../types/internal'

interface PixelBattleOptions extends Options, WSOptions {}

export default {
  defaultOptions: host => ({
    shouldInstantiateWS: typeof window !== 'undefined',
    hostWS: host,
    pathWS: 'pxart/connection'
  }),

  factory: ({ shouldInstantiateWS, hostWS, pathWS }, { module }) => {
    if (pathWS === undefined) {
      throw new ReferenceError('pathWS must be specified in defaultOptions')
    }

    let ws: WSS | null = null

    if (shouldInstantiateWS) {
      const { href } = new URL(pathWS, hostWS || location.origin)
      ws = new WSS(href)
    }

    if (ws) {
      ws.getAuthorizationToken = () =>
        module('auth').then(({ getAuthorizationToken }) =>
          getAuthorizationToken()
        )
    }

    const getWSInstance = () => {
      if (!ws) {
        throw new TypeError('WS is not instantiated')
      }

      return ws
    }

    return { ws, getWSInstance }
  }
} satisfies Starter<PixelBattleOptions>
